import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "change-history_d36b0",
  "use": "change-history_d36b0-usage",
  "viewBox": "0 0 13 12",
  "content": "<symbol viewBox=\"0 0 13 12\" id=\"change-history_d36b0\">\n    <path fill=\"inherit\" d=\"M0 7h3v5H0zm5-7h3v12H5zm5 4h3v8h-3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol